// extracted by mini-css-extract-plugin
var _1 = "Uploader-module__fullHeightContainer--YA9eR";
var _2 = "Uploader-module__info--xSIzF";
var _3 = "Uploader-module__uploader--mpnaH";
var _4 = "Uploader-module__uploaderAccept--RBYsK";
var _5 = "Uploader-module__uploaderIcon--AIHrg";
var _6 = "Uploader-module__uploaderReject--LzJOs";
var _7 = "Uploader-module__wrappingGroup--qPUV9";
export { _1 as "fullHeightContainer", _2 as "info", _3 as "uploader", _4 as "uploaderAccept", _5 as "uploaderIcon", _6 as "uploaderReject", _7 as "wrappingGroup" }
